module.exports = __webpack_public_path__ + "static/media/sport_feminin.90ab96da.jpg";